import type { ReactNode } from "react";
import { cn } from "../../utils/bem";
import "./SummaryStrip.prefix.css";

export type SummaryItem = {
  label: ReactNode;
  value: ReactNode;
  sub?: ReactNode;
  tone?: "default" | "positive" | "negative" | "warning";
};

type SummaryStripProps = {
  items: SummaryItem[];
  className?: string;
};

const block = cn("summary-strip");

export const SummaryStrip = ({ items, className }: SummaryStripProps) => {
  const visible = items.filter((i) => i.value !== undefined && i.value !== null);
  if (visible.length === 0) return null;

  const rootClassName = className ? `${block.toClassName()} ${className}` : block.toClassName();

  return (
    <div className={rootClassName}>
      {visible.map((item, idx) => {
        const toneClass =
          item.tone && item.tone !== "default"
            ? block.elem("item").mod({ tone: item.tone }).toClassName()
            : block.elem("item").toClassName();
        return (
          <div key={idx} className={toneClass}>
            <span className={block.elem("value").toClassName()}>{item.value}</span>
            <span className={block.elem("label").toClassName()}>{item.label}</span>
            {item.sub != null && <span className={block.elem("sub").toClassName()}>{item.sub}</span>}
          </div>
        );
      })}
    </div>
  );
};
